<template>
  <div>
    <section class="page-panel-rule">
      <panel>
        <!-- 标题 -->
        <template slot="title">
          <span>规则</span>
        </template>
        <div class="mwe-panel-expand-content">
          <!-- 规则列表 S  -->
          <div class="rule-list">
            <div class="rule-cont">
              <p>
                1. 用户需持有腾讯Nintendo
                Switch设备，并关联微信账号方可参与活动；
              </p>
              <p>
                2.
                本次活动所有优惠券有效期为12月10日-12日，过期无效，优惠券均不可叠加使用；
              </p>
              <p>
                3. 全场无门槛-15元优惠券，每人每天至多可领取一张；
              </p>
              <p>
                4.
                由于数据回传等原因，若出现已购买国行游戏却未获得抽奖机会等情况，请先确认游戏账号是否已绑定微信，并已在联网状态下启动过游戏。耐心等待一段时间后再次进入页面即可获得抽奖资格；
              </p>
              <p>
                5. 抽奖活动中奖品Q币均有兑换时效，在获得奖品后请尽快兑换；
              </p>
              <p>
                6.
                活动期间，如用户以任何不正当方式参与活动，一经发现，腾讯Nintendo
                Switch有权以不发放奖励或追讨已发放奖励等措施进行处理，并保留追究用户责任的权利。不正当的手段及舞弊行为包括但不限于作弊领取、虚假操作、机器刷奖、恶意套取奖品、使用黑客工具等；
              </p>
              <p>
                7. 本活动由腾讯游戏主办，如有疑问，请前往“腾讯Nintendo
                Switch”官方公众号，点击右下角自定义菜单“我的客服”与客服取得联系。
              </p>
            </div>
          </div>
          <!-- 规则列表 E  -->
        </div>
      </panel>
    </section>
  </div>
</template>

<script>
import { pgvEventReport } from '@/libs/tcss-report';

import Panel from '@/components/panel.vue';
export default {
  name: 'Home',
  components: { Panel },
  data() {
    return {};
  },
  mounted() {
    pgvEventReport('anniversary.activity.page.rule');
  },
  methods: {}
};
</script>
<style lang="scss">
@import '../assets/css/pages/rule.css';
</style>
